<template>
    <div class="qksm qksm10 page">
        <h4>十、关于国有资本经营预算支出表的说明</h4>
        <p v-if="T10.总计==0">
            {{$store.state.divData.divname}}{{$parent.year}}年没有使用国有资本经营预算拨款安排的支出。
        </p>
        <div class="nogap" v-else>
            <p>
                {{$store.state.divData.divname}}{{$parent.year}}年国有资本经营预算当年拨款{{isMoney(T10.总计)}}万元，
                <span class="hide_pdf">
                    （去年预算数<reason type="money" classname="qksm money editLast" name="T10总计last" v-model:value="T10['总计last']"></reason>万元）
                </span>
                <span v-if="num(T10.总计).toFixed(2)==num(T10['总计last']).toFixed(2)">
                    与上年预算数相同。
                </span>
                <span v-else>
                    比上年{{growthValueText(T10.总计,T10['总计last'])}}万元
                    <span v-if="num(T10['总计last'])==0">
                        （去年预算数为0万元，无法计算增减比率）。
                    </span>
                    <span v-else>
                        ，{{growthRatioText(T10.总计,T10['总计last'])}}。
                    </span>
                    主要原因是<reason type="textarea" classname="qksm widest because" name="T10原因" v-model:value="qksm['T10原因']"></reason>
                </span>
            </p>
            <p>
                {{$parent.year}}年当年国有资本经营预算支出为{{isMoney(T10.总计)}}万元。具体情况如下：
            </p>
            <p>
                <template v-for="(item,idx) in (T10.items)" :key="idx">
                    {{T10.items.length>1 ? (idx+1)+"、" :""}}{{item.lei}}{{item.kuan}}{{item.xiang}}支出{{isMoney(item.value)}}万元，
                    <span class="hide_pdf">
                        （去年预算数<reason type="money" classname="qksm money editLast" :name="'T10last'+item.code" v-model:value="qksm['T10last'+item.code]"></reason>万元）
                    </span>
                    主要是
                    <reason type="textarea" classname="qksm widest because semicolon" :name="'T10主要是'+item.code" v-model:value="qksm['T10主要是'+item.code]"></reason>
                    <span v-if="num(item.value).toFixed(2)==num(qksm['T10last'+item.code]).toFixed(2)">
                        与上年预算数相同。
                    </span>
                    <span v-else>
                        比上年{{growthValueText(item.value,qksm['T10last'+item.code])}}万元
                        <span v-if="num(qksm['T10last'+item.code])==0">
                            （去年预算数为0万元，无法计算增减比率）。
                        </span>
                        <span v-else>
                            ，{{growthRatioText(item.value,qksm['T10last'+item.code])}}。
                        </span>
                        主要原因是<reason type="textarea" classname="qksm widest because" :name="'T10原因'+item.code" v-model:value="qksm['T10原因'+item.code]"></reason>
                    </span>
                </template>
            </p>
            
        </div>
        <p></p>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm10",
        props: {
            T10: {
                type: Object,
                default: "",
            },
        },
        data() {
            var qksm = this.$store.state.divData.qksm;
            if (qksm['T10总计last'])
                this.T10['总计last'] = qksm['T10总计last'];
            for(let item of this.T10.items) {
                qksm['T10last' + item.code] = this.pickOneOf(qksm['T10last' + item.code], item.lastvalue)
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
            }
        },
        components: {
            reason,
        },
    };
</script>
